import React, { useEffect, useState } from 'react';
import { tr } from '../../i18n';
import { Link } from 'react-router-dom';
import './CookieConsentBanner.css';

const STORAGE_KEY = 'rr_cookie_notice_dismissed';

/** Инфо-баннер о cookie: не блокирует контент, факт закрытия хранится в localStorage. */
const CookieConsentBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(STORAGE_KEY) === '1');
    } catch {
      setDismissed(false);
    }
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // localStorage недоступен (приватный режим и т.п.) — баннер просто не переживёт перезагрузку
    }
  };

  if (dismissed) return null;

  return (
    <div className="cookie-banner" role="status">
      <p className="cookie-banner-text">
        {tr.shell.cookieBanner.textPrefix}{' '}
        <Link to="/privacy#cookies">{tr.shell.cookieBanner.link}</Link>.
      </p>
      <button type="button" className="cookie-banner-button" onClick={handleDismiss}>
        {tr.shell.cookieBanner.dismiss}
      </button>
    </div>
  );
};

export default CookieConsentBanner;
